module.exports = __webpack_public_path__ + "b36dc87223516ae6175ca69742b05c5e.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Help/screenshots/login-bottom.PNG
// module id = 1053
// module chunks = 0